import { environment } from 'environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Entity, SalesPersonCustomerAddressDTO } from '../models/entity-model';
import { UserEntity } from '../models/userEntity';


@Injectable({
    providedIn: 'root'
})
export class EntitiesService {

    private API_ENTITY_TYPE_URL = environment.ipserver + 'AnA-backend/private/entity';

    private API_UPDATE_ENTITY_URL = environment.ipserver + 'AnA-backend/private/entity/updateEntityTypeEntity';

    constructor(private http: HttpClient) { }

    /**
     * Method that obtains a list of entity types by calling applicatios rest service
     * @author Castor Transformación Digital - Fabio Oquendo
     * @since 2020-02-07
     * @return Observable with a json that contains a list of entity types
     */
    public getAllEntityTypes(): Observable<any> {
        return this.http.get<any>(`${this.API_ENTITY_TYPE_URL}/findAll`);
    }

    /**
     * Method that obtains a entity type by calling applicatios rest service
     * @author Castor Transformación Digital - Fabio Oquendo
     * @since 2020-02-07
     * @param id: The entity type id
     * @return Observable with a json that contains a list of entity types
     */
    public getEntityType(id: number): Observable<Entity> {
        const httpHeaders = new HttpHeaders();
        httpHeaders.set('Content-Type', 'application/json');
        return this.http.post<Entity>(`${this.API_ENTITY_TYPE_URL}/findById`, id, { headers: httpHeaders });
    }

    /**
     * Method that obtains a list of entity types by calling applicatios rest service
     * @author Castor Transformación Digital - Fabio Oquendo
     * @since 2020-02-07
     * @param entity type: The entity type
     * @return Observable with a json that contains a list of entity types
     */
    public addEntity(entity: Entity): Observable<any> {
        const httpHeaders = new HttpHeaders();
        const type = 'text' as 'json';
        httpHeaders.set('Content-Type', 'application/json');
        return this.http.post<any>(`${this.API_ENTITY_TYPE_URL}/addEntityTypeEntity`, entity, { headers: httpHeaders, responseType: type });
    }

    /**
     * Method that obtains a list of entity types by calling applicatios rest service
     * @author Castor Transformación Digital - Fabio Oquendo
     * @since 2020-02-07
     * @param id: The entity type id
     * @return Observable with a json that contains a list of entity types
     */
    public removeEntity(entity: Entity): Observable<any> {
        const httpHeaders = new HttpHeaders();
        const type = 'text' as 'json';
        httpHeaders.set('Content-Type', 'application/json');
        return this.http.post<any>(`${this.API_ENTITY_TYPE_URL}/removeEntityTypeEntity`,
            entity, { headers: httpHeaders, responseType: type });
    }

    /**
     * TODO: Check That applications are not using this method to check for user's entities 4/21/2021. Only AnA can use this method
     * Method that obtains a list of entities associateds to a user
     * @author Castor Transformación Digital - Fabio Oquendo
     * @since 2020-02-03
     * @return Observable with a json that contains a list of roles
     */
    public findEntitiesAssociated(username: string): Observable<any> {
        let paramsForReq: any;
        paramsForReq = new HttpParams().set('name', username);
        return this.http.get<Array<Entity>>(`${this.API_ENTITY_TYPE_URL}/findByName`, { params: paramsForReq });
    }

    /**
     * Method that create a list associations between entities and user
     * @author Castor Transformación Digital - Fabio Oquendo
     * @since 2020-03-24
     */
    public addEntityUser(userEntities: Array<UserEntity>) {
        const httpHeaders = new HttpHeaders();
        const type = 'text' as 'json';
        httpHeaders.set('Content-Type', 'application/json');
        return this.http.post<any>(`${this.API_ENTITY_TYPE_URL}/addEntityUser`, userEntities, { headers: httpHeaders, responseType: type });
    }

    /**
     * Method that remove a list associations between entities and user
     * @author Castor Transformación Digital - Fabio Oquendo
     * @since 2020-03-24
     */
    public removeEntityUser(userEntities: Array<UserEntity>) {
        const httpHeaders = new HttpHeaders();
        const type = 'text' as 'json';
        httpHeaders.set('Content-Type', 'application/json');
        return this.http.post<any>(`${this.API_ENTITY_TYPE_URL}/removeEntityUser`,
            userEntities, { headers: httpHeaders, responseType: type });
    }

    /**
     * Modifies an entity data
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-03-27
     * @param entity The entity to be modified
     * @return Observable with a json text
     */
    public updateEntityTypeEntity(entity: Entity): Observable<string> {
        const type = 'text' as 'json';
        return this.http.post<any>(this.API_UPDATE_ENTITY_URL, entity, { responseType: type });
    }


    public updateCustomerAddressesEntity(entity :SalesPersonCustomerAddressDTO[] ): Observable<any> {
        const httpHeaders = new HttpHeaders();
        const type = 'text' as 'json';
        httpHeaders.set('Content-Type', 'application/json');
        return this.http.post<any>(`${this.API_ENTITY_TYPE_URL}/updateCustomerAddressesEntity`, entity, { headers: httpHeaders, responseType: type });
    }

}
